// extracted by mini-css-extract-plugin
module.exports = {"modal":"PesoModal_modal__UMmvG","amount":"PesoModal_amount__3OAac"};